import "./Contact.scss";
import { useState } from "react";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import errorImg from "../../assets/icons/error.svg";
import Input from "../../components/Input/Input";
import Button from "../Button/Button.js";

function Contact({ toggleDarkMode }) {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const form = useRef();

  const [fields, setFields] = useState({
    name: "",
    email: "",
    message: "",
  });
  const handleChange = (event) => {
    setFields({ ...fields, [event.target.name]: event.target.value });
  };
  const isFormValid = () => {
    if (!fields.name || !fields.message || !fields.email) {
      return false;
    }
    return true;
  };
  const isEmailValid = () => {
    if (!fields.email.includes("@")) {
      return false;
    }
    return true;
  };
  const isNameValid = () => {
    const re = /^[a-zA-Z ]*$/;
    if (!re.test(fields.name)) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!isFormValid()) {
      setError(true);
      return;
    } else {
      setError(false);
      try {
        const response = await emailjs.sendForm(
          process.env.REACT_APP_SERVICE_ID,
          process.env.REACT_APP_TEMPLATE_ID,
          form.current,
          process.env.REACT_APP_PUBLIC_KEY
        );
        if (response.status === 200) {
          setSuccess(true);
          setFields();
        }
      } catch (error) {
        console.error(error);
        setError(error.response.data);
      }
    }
  };

  return (
    <section className={toggleDarkMode ? "contact contact--dark" : "contact"}>
      {!success && (
        <div className="contact__container">
          <div className="contact__text">
            <h1 className="contact__title">Contact</h1>
            <p className="contact__subtitle">
              Feel free to reach out to me directly via{" "}
              <span className="contact__email">
                <a
                  href="mailto:louisohara20@gmail.com"
                  className={
                    toggleDarkMode
                      ? "contact__link contact__link--dark"
                      : "contact__link"
                  }
                >
                  email
                </a>
              </span>{" "}
              or by using the form below.
            </p>
          </div>
          <div className="contact__form-wrapper">
            <form className="contact__form" ref={form} onSubmit={handleSubmit}>
              <div className="contact__flex">
                <div className="contact__wrapper">
                  <Input
                    type="text"
                    name="name"
                    label="Name"
                    onChange={handleChange}
                    placeholder="Your name"
                    alt={error && !fields.name ? "error" : ""}
                    toggleDarkMode={toggleDarkMode}
                    autoComplete="name"
                  />
                  {(error && !fields.name) || (error && !isNameValid()) ? (
                    <div className="contact__error-container">
                      <img
                        src={errorImg}
                        className="contact__icon"
                        alt="error icon"
                      />
                      <p className="contact__error">
                        {fields.name ? "Enter valid name" : "Required field"}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="contact__wrapper">
                  <Input
                    type="text"
                    name="email"
                    label="Email"
                    onChange={handleChange}
                    placeholder="Your email"
                    alt={error && !fields.email ? "error" : ""}
                    toggleDarkMode={toggleDarkMode}
                    autoComplete="email"
                  />{" "}
                  {(error && !fields.email) || (error && !isEmailValid()) ? (
                    <div className="contact__error-container">
                      <img
                        src={errorImg}
                        className="contact__icon"
                        alt="error icon"
                      />
                      <p className="contact__error">
                        {fields.email ? "Enter valid email" : "Required field"}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="contact__message field">
                <label htmlFor="message" className="field__label">
                  Message
                </label>
                <textarea
                  className={`contact__textarea field__input  field__input--textarea ${
                    error && !fields.message ? "field__input--error" : ""
                  } ${toggleDarkMode ? `field__input--dark` : ``}`}
                  type="textarea"
                  name="message"
                  id="message"
                  onChange={handleChange}
                  placeholder="Your message"
                ></textarea>

                {error && !fields.message ? (
                  <div className="contact__error-container">
                    <img
                      src={errorImg}
                      className="contact__icon"
                      alt="error icon"
                    />
                    <p className="contact__error">Required field</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="contact__button-container">
                <Button children={"Send"} toggleDarkMode={toggleDarkMode} />
              </div>
            </form>
          </div>
        </div>
      )}
      {success && (
        <div className="contact__text contact__text--success">
          <h1 className="contact__title contact__title--success">
            Thanks for being in touch!
          </h1>
          <p className="contact__subtitle contact__subtitle--success">
            Your email was sent successfully
          </p>
        </div>
      )}
    </section>
  );
}

export default Contact;
